(function () {
  function navCta() {
    document.querySelectorAll('header a, #header-group a').forEach(function (a) {
      if (/get yours/i.test(a.textContent)) a.classList.add('zl-nav-cta');
    });
  }
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    var sel = '.zl .zl-h2,.zl-card,.zl-step,.zl-compare__table,.zl-faq details,.zl-ugc__card,.zl-trust__item,.zl-promise__box,.zl-reveal';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('zl-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll(sel).forEach(function (el, i) {
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = (Math.min(sib, 5) * 90) + 'ms';
      el.classList.add('zl-pre');
      io.observe(el);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zl-scroll]');
    if (b) {
      var t = document.getElementById(b.getAttribute('aria-controls'));
      if (t) t.scrollBy({ left: (b.getAttribute('data-zl-scroll') === 'next' ? 1 : -1) * t.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var s = e.target.closest('.zl-ugc__sound');
    if (s) {
      var v = s.parentElement.querySelector('video');
      if (!v) return;
      document.querySelectorAll('.zl-ugc__media video').forEach(function (o) { if (o !== v) { o.muted = true; } });
      v.muted = !v.muted;
      if (!v.muted) v.play();
      s.setAttribute('aria-pressed', String(!v.muted));
    }
  });
  function init() { navCta(); reveal(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
